// Funciones generales: alertas, modales y utilidades de texto.
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import Swal from "sweetalert2";

export const funcionesGenerales = {
  async cerrarModal() {
    try {
      // eslint-disable-next-line no-undef -- $ es el jQuery global
      $(".modal").modal("hide");
    } catch (error) {
      console.log(error);
    }
  },
  async enDesarrollo() {
    Swal.fire({
      title: "Submódulo en desarrollo...",
      text: "Disponible próximamente...",
      icon: "info",
      confirmButtonText: "Entendido",
      confirmButtonColor: "#073d7a",
    });
  },
  // OCULTAR CARACTERES
  ocultarCaracteres(value, count) {
    if (!value) return "";
    const valStr = value.toString();
    if (valStr.length > count) {
      return "*".repeat(valStr.length - count) + valStr.slice(-count);
    }
    return valStr;
  },
  // OCULTAR CORREO
  ocultarCorreo(correo) {
    if (!correo) return "";
    const correoStr = correo.toString();
    let hiddenEmail = "";
    for (let i = 0; i < correoStr.length; i++) {
      if (i < correoStr.indexOf("@")) {
        hiddenEmail += "*";
      } else {
        hiddenEmail += correoStr[i];
      }
    }
    return hiddenEmail;
  },
  // Funciones de alertas
  // pasos (opcional): lista de indicaciones concretas para el usuario. Si se envía,
  // se muestra arriba del código de error y reemplaza los tres pasos genéricos.
  async alerta(tipo = "info", titulo = "", msg = "", error = "", pasos = []) {
    let contenido = "";
    if (tipo == "success" && msg != "") {
      contenido = `
        <div class="p-2 rounded border text-start">
          <p style="color: #222" class="mb-0"><b>📌 </b>${msg}</p>
        </div>
        `;
    } else if (tipo == "info" && msg != "") {
      contenido = `
        <div class="p-2 rounded border text-start">
          <p style="color: #222" class="mb-0"><b>📌 </b>${msg}</p>
        </div>
        `;
    } else if (tipo == "warning" && msg != "") {
      contenido = `
        <div class="p-2 rounded border text-start">
          <p style="color: #222" class="mb-0"><b style="color: rgb(0, 0, 0)">📌 </b>${msg}</p>
        </div>
        `;
    } else if (tipo == "question" && msg != "") {
      contenido = `
        <div class="p-2 rounded border text-start">
          <p style="color: #222" class="mb-0"><b>📌 </b>${msg}</p>
        </div>
        `;
    } else if (tipo == "error") {
      const listaPasos = Array.isArray(pasos) ? pasos : pasos ? [pasos] : [];
      const bloquePasos = listaPasos.length
        ? `
          <div class="p-2 rounded border text-start mb-3" style="background-color: #f8f9fa">
            <p style="color: #222" class="mb-1"><b>¿Qué puedes hacer?</b></p>
            <ul style="color: #222" class="mb-0 ps-3">${listaPasos
          .map((paso) => `<li class="mb-1">${paso}</li>`)
          .join("")}</ul>
          </div>
          `
        : "";
      const bloqueCierre = listaPasos.length
        ? `<p style="color: #222" class="mb-0"><b>¿Sigue pasando?</b> Toma captura de pantalla de esta ventana y comunícate con <a href="/soporte" class="text-dark font-weight-bold"><i class="fas fa-envelope-open-text"></i> Soporte Técnico</a></p>`
        : `<p style="color: #222"><b>1.</b> Ha ocurrido un error en la operación, vuelve a intentarlo.</p>
          <p style="color: #222"><b>2.</b> Toma captura de pantalla o copia el texto del error para una solución más eficiente.</p>
          <p style="color: #222"><b>3.</b> Si el error persiste, comunícate con <a href="/soporte" class="text-dark font-weight-bold"><i class="fas fa-envelope-open-text"></i> Soporte Técnico</a></p>`;
      contenido = `
        <div class='text-start'>
          ${bloquePasos}
          <p style="color: #222"><b>Código de Error: </b>${msg}</p>
          <textarea class="form-control rounded" rows="${listaPasos.length ? 3 : 5}" disabled>${error}</textarea><br>
          ${bloqueCierre}
        </div>
        `;
    }
    await Swal.fire({
      icon: tipo,
      background: "rgba(255, 255, 255)",
      backdrop: `rgba(0,0,0,0.7)`,
      title: '<h6 class="text-dark">' + titulo + "</h6>",
      html: contenido,
      confirmButtonText: "Entendido",
      showConfirmButton: true,
      showCancelButton: false,
      reverseButtons: false,
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary btn-md fw-bold mb-2",
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  },
  alertaValidacionCedula() {
    Swal.fire({
      icon: "info",
      background: "rgba(51, 51, 102, 0.7)",
      buttonsStyling: false,
      backdrop: `rgba(0,0,0,0.8)`,
      confirmButtonText: "Entendido",
      customClass: {
        popup: "swal-radius",
        confirmButton:
          "btn btn13 btnalerta btn-md font-weight-bold mr-2 mb-3",
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      position: "center",
      title:
        "<h4 style='color: white'>Si el número de identificación registrado no es correcto.</h4>",
      html: '<p style="color: rgb(0,0,0)">Contacta con el <a href="/soportetecnico" class="text-dark font-weight-bold"><i class="fas fa-envelope-open-text"></i> Soporte Técnico</a> para corregir esta información.</p>',
      showConfirmButton: true,
    });
  },
  // Funciones de espera
  async esperar(tiempo) {
    return new Promise((resolve) => {
      setTimeout(resolve, tiempo);
    });
  },
};
